/* Homepage-only interactions for the approved design. No cart, checkout or tracking hooks. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const stories = [
    ['Joseph says the balcony setup made life with a new puppy so much easier that his family purchased a second Porch Potty.', 'Joseph S. · Verified buyer · Premium'],
    ['Phoenix uses it for the first morning break, then enjoys a regular walk later, making apartment life feel less rushed.', 'Phoenix · Standard customer'],
    ['Diana says the second-floor routine became easier, and family members could comfortably help watch Bella and Wookie.', 'Diana P. · Verified buyer · Premium'],
    ['Melissa says the second-story drainage setup made weekly cleaning straightforward and helped keep the balcony routine manageable.', 'Melissa C. · Standard customer'],
    ['Linda used hers through apartment living and a move to a new home, replacing the original after approximately three and a half years.', 'Linda D. · Verified buyer · Small']
  ];
  function initialize(scope = document) {
    scope.querySelectorAll('.pp-approved').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cleanups = [];
      root.ppCleanup = () => cleanups.forEach(fn => fn());
      const selectAll = selector => [...root.querySelectorAll(selector)];
      const featureButtons = selectAll('.use-tab,.core-tab');
      const slides = selectAll('.hero-slide');
      const section = root.querySelector('section');
      if (featureButtons.length || slides.length) {
        const items = featureButtons.length ? featureButtons : slides;
        const media = root.querySelector('.usecase-media,.spotlight-media,.hero-media');
        const img = featureButtons.length ? media.querySelector('img') : null;
        let index = 0, timer, visible = false, hovered = false, focused = false, paused = reduced.matches;
        const toggle = featureButtons.length ? document.createElement('button') : null;
        if (toggle) {
          toggle.type = 'button'; toggle.className = 'pp-motion-toggle';
          media.append(toggle);
        }
        function updateToggle() { if (!toggle) return; toggle.textContent = paused ? 'Play slideshow' : 'Pause slideshow'; toggle.setAttribute('aria-pressed', String(paused)); }
        function schedule() {
          clearTimeout(timer);
          const play = visible && !paused && !document.hidden && !reduced.matches;
          const progress = root.querySelector('.slider-progress span');
          if (progress) { progress.style.animation = 'none'; if (play) { void progress.offsetWidth; progress.style.animation = 'ppDesignLoad 6s linear'; } }
          if (play) timer = setTimeout(() => { select((index + 1) % items.length); }, 6000);
        }
        function select(next) {
          index = next;
          items.forEach((el, i) => { el.classList.toggle(featureButtons.length ? 'active' : 'is-active', i === index); if (featureButtons.length) el.setAttribute('aria-pressed', String(i === index)); });
          if (img) { img.src = items[index].dataset.img; img.alt = items[index].dataset.alt; img.title = img.alt; img.classList.toggle('product-first', !!root.querySelector('.core-tab') && index === 0); }
          schedule();
        }
        featureButtons.forEach((button, i) => button.addEventListener('click', () => select(i)));
        const heroThumbs = selectAll('[data-hero-slide]');
        heroThumbs.forEach((button) => button.addEventListener('click', event => {
          event.preventDefault();
          const nextIndex = Number(button.dataset.heroSlide);
          if (!Number.isNaN(nextIndex)) select(nextIndex);
        }));
        const syncHeroThumbs = () => heroThumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        if (heroThumbs.length) {
          const originalSelect = select;
          select = nextIndex => {
            originalSelect(nextIndex);
            syncHeroThumbs();
          };
          syncHeroThumbs();
        }
        toggle?.addEventListener('click', () => { paused = !paused; updateToggle(); schedule(); });
        section.addEventListener('mouseenter', () => { hovered = true; schedule(); });
        section.addEventListener('mouseleave', () => { hovered = false; schedule(); });
        section.addEventListener('focusin', () => { focused = true; schedule(); });
        section.addEventListener('focusout', event => { if (!section.contains(event.relatedTarget)) { focused = false; schedule(); } });
        const visibility = () => schedule(); document.addEventListener('visibilitychange', visibility);
        const motion = () => { paused = reduced.matches; updateToggle(); schedule(); }; reduced.addEventListener('change', motion);
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: .15}); observer.observe(section);
        cleanups.push(() => { clearTimeout(timer); observer.disconnect(); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', motion); });
        // Match the reference's mobile order: heading, photo, then controls.
        const small = window.matchMedia('(max-width:620px)');
        const arrange = () => {
          if (!featureButtons.length) return;
          const copy = root.querySelector('.usecase-copy,.spotlight-copy');
          const stage = root.querySelector('.usecase-stage,.spotlight-grid');
          if (small.matches) copy.insertBefore(media, copy.querySelector('.slider-progress'));
          else stage.insertBefore(media, stage.firstChild);
        };
        small.addEventListener('change', arrange); cleanups.push(() => small.removeEventListener('change', arrange));
        arrange(); updateToggle(); select(0);
      }
      selectAll('.evidence-nav button').forEach((button, i, buttons) => button.addEventListener('click', () => {
        buttons.forEach(b => { b.classList.toggle('active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
        root.querySelector('.evidence-main blockquote').textContent = stories[i][0];
        root.querySelector('.evidence-main footer').textContent = stories[i][1];
      }));
      const track = root.querySelector('.product-grid');
      if (track) {
        const arrows = selectAll('.model-arrow');
        arrows.forEach((button, i) => button.addEventListener('click', () => track.scrollBy({left:(i ? 1 : -1) * (track.clientWidth + 20), behavior:reduced.matches ? 'instant' : 'smooth'})));
        const update = () => { if (arrows[0]) arrows[0].disabled = track.scrollLeft <= 2; if (arrows[1]) arrows[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
        track.addEventListener('scroll', update, {passive:true}); const observer = new ResizeObserver(update); observer.observe(track); cleanups.push(() => observer.disconnect()); update();
      }
      const dialog = root.querySelector('#v5-model-comparison');
      if (dialog) {
        let trigger, originalOverflow;
        const close = () => { dialog.hidden = true; document.body.style.overflow = originalOverflow; trigger?.focus(); };
        selectAll('[href="#v5-model-comparison"],[data-open-comparison]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); trigger = button; originalOverflow = document.body.style.overflow; dialog.hidden = false; document.body.style.overflow = 'hidden'; dialog.querySelector('.v5-compare-close').focus(); }));
        selectAll('.v5-compare-close,.v5-compare-done').forEach(button => button.addEventListener('click', close));
        dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
        dialog.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); close(); }
          if (event.key !== 'Tab') return;
          const focusable = [...dialog.querySelectorAll('button,a[href],[tabindex="0"]')].filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
        cleanups.push(() => { if (!dialog.hidden) close(); });
      }
      const demos = selectAll('[data-motion-src]');
      if (demos.length) {
        let visible = false, paused = false;
        const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'pp-motion-toggle how-motion-toggle'; section.querySelector('.how-grid').after(toggle);
        const sync = () => { const playing = visible && !paused && !reduced.matches && !document.hidden; demos.forEach(img => { const src = playing ? img.dataset.motionSrc : img.dataset.staticSrc; if (img.getAttribute('src') !== src) img.src = src; }); toggle.textContent = paused ? 'Play demonstrations' : 'Pause demonstrations'; toggle.hidden = reduced.matches; };
        toggle.addEventListener('click', () => { paused = !paused; sync(); });
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }); observer.observe(section);
        reduced.addEventListener('change', sync); document.addEventListener('visibilitychange', sync); sync();
        cleanups.push(() => { observer.disconnect(); reduced.removeEventListener('change', sync); document.removeEventListener('visibilitychange', sync); });
      }
      selectAll('video').forEach(video => {
        const card = video.closest('.video-card');
        if (!card) return;
        // Use one set of native controls; overlays must not cover iOS controls.
        card.querySelector('.pp-video-play')?.remove();
        video.controls = true;
        video.addEventListener('play', () => {
          document.querySelectorAll('.pp-approved video').forEach(other => { if (other !== video) other.pause(); });
          const caption = card.querySelector('.video-caption');
          if (caption) caption.hidden = true;
        });
        // Fullscreen can make the inline video non-intersecting on iOS.
        // Keep playback under the native player's control during that transition.

      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.pp-approved').forEach(root => root.ppCleanup?.()));
})();

